import React from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import { IMetaFormat } from '../../../../../store/admin/roundFormats/store';
import { ScoreType } from '../../../../../store/admin/eventFormats/store';

import YesNoSwitch from '../../../../../components/YesNoSwitch';

interface IProps {
  metaFormatToUpdate: IMetaFormat;
  onSaveMetaFormat: (format: IMetaFormat) => void;
}

export const WhichScoresForEvent = (props: IProps) => {
  const { metaFormatToUpdate, onSaveMetaFormat } = props;
  const { scoreTypes } = metaFormatToUpdate;

  const onToggleScore = (scoreType: ScoreType) => async () => {
    const newScoreTypes = scoreTypes.includes(scoreType)
      ? scoreTypes.filter(prevScoreType => prevScoreType !== scoreType)
      : [...scoreTypes, scoreType];

    onSaveMetaFormat({ ...metaFormatToUpdate, scoreTypes: newScoreTypes });
  };

  const toggleAdjustedHandicap = () => {
    onSaveMetaFormat({
      ...metaFormatToUpdate,
      adjustedHandicap: !metaFormatToUpdate.adjustedHandicap
    });
  };

  return (
    <>
      {metaFormatToUpdate.format.optionalScores && (
        <>
          <p className="format-label">WHICH SCORES WILL COUNT IN THIS EVENT?</p>

          <FormControlLabel
            className="round-subformat-checkbox override"
            classes={{ label: 'label' }}
            control={
              <Checkbox
                className="check-gross-score"
                checked={metaFormatToUpdate.scoreTypes.includes(ScoreType.GROSS)}
                onChange={onToggleScore(ScoreType.GROSS)}
                icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                checkedIcon={<CheckBoxIcon fontSize="large" />}
                value="on"
                color="primary"
              />
            }
            label="Gross score"
          />

          <FormControlLabel
            className="round-subformat-checkbox override"
            classes={{ label: 'label' }}
            control={
              <Checkbox
                className="check-gross-score"
                checked={metaFormatToUpdate.scoreTypes.includes(ScoreType.NET)}
                onChange={onToggleScore(ScoreType.NET)}
                icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                checkedIcon={<CheckBoxIcon fontSize="large" />}
                value="on"
                color="primary"
              />
            }
            label="Net score"
          />
        </>
      )}

      {metaFormatToUpdate.format.adjustedHandicap && scoreTypes.includes(ScoreType.NET) && (
        <div className="adjustedHandicapSection">
          <p className="format-label">HOW HANDICAPS ARE CALCULATED?</p>

          <YesNoSwitch
            labelNo="All players play their handicap"
            labelYes="Adjusted to lowest handicap"
            onChange={toggleAdjustedHandicap}
            checked={metaFormatToUpdate.adjustedHandicap}
          />
        </div>
      )}
    </>
  );
};
